// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__MwAzc","productName":"Table_productName__2sVSf"};